export default __webpack_public_path__ + "static/media/first-open-process.566a2706.svg";